module.exports = __webpack_public_path__ + "355CC9_2_0.woff2?679e52baa93480d378e92c2244339838";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_2_0.woff2
// module id = 37
// module chunks = 0